import { RegionTypeEnum } from '../../_util/enum';
// 时区map
export const ZONE_ENUM_MAP = {
    [RegionTypeEnum.HK]: 'Asia/Shanghai',
    [RegionTypeEnum.US]: 'America/New_York',
};
